import { PaginationEndMsg } from "../../utils/Languages";

const PaginationScrollEndMsg = () => {
  return (
    <p className="event-pagination-end-msg">
      <b>{PaginationEndMsg}</b>
    </p>
  );
};

export default PaginationScrollEndMsg;
